export const CISCO_HYPERFLEX_FAQ_LIST = [
  {
    title: "Do you sell/Provide workbooks with  HX LABS ?",
    content:
      "No, but we do provide detailed  Sample Labs/Configuration Examples and you can use our labs with any vendor labs.  You can check the documentation Section, we partner with Industry’s top consultants to build those samples.",
  },
  {
    title: "Do you offer  Training for the Learning Labs ?",
    content:
      "CloudMyLab is an Infrastructure Provider and we do not offer any  Virtual or In-person Training, However, we will be happy to connect you with our awesome training Partners Patriot Solutions and Training world 360.",
  },
  {
    title: "Are these Labs locked to a certain configurations only ?",
    content:
      "The only thing fixed in the setup is IP schema and Cluster Interface.  You can feel free to change things around, upload/Create your own virtual machines and tie it back to the Lab.",
  },
  {
    title: "What does 2 Days access Mean ?",
    content:
      "2 Day Access Means that you will have access to the Lab for 2 Calendar Days 24X2.",
  },
  {
    title:
      "I am stuck and need help configuring HX or need a consult on an integration, can you guys Help ?",
    content:
      "Yes, we can engage our Professional Services Team.  As a general rule, our Level 1 support team is not equipped to troubleshoot specific scenarios built by you.",
  },
  {
    title: "So what does your Level 1 Support do ?",
    content:
      "Our Level 1 Support will ensure that your Lab infrastructure and underlying automation is in perfect condition, so you can do what you like.",
  },
  {
    title: "What can I accomplish on your Lab Infrastructure with HX ?",
    content:
      "You could use our Sample Labs to get started and you can build on top of it. All the Features are supported as listed out the software release of the version.",
  },
  {
    title: "What if I need additional Hardware or software ?",
    content:
      "The Learning Labs are general purpose labs and you can attach anything virtual by using the UCS in the lab environment, for additional Hardware , please utilize our POC-AS-A-Service or LAB-As-A Service.",
  },
];

export const CISCO_HYPERFLEX_HW_LIST = [
  "Cisco HX Version 4.X",
  "3 X HX C220/240 Nodes",
  "2 X FI-6248 Fabric Interconnects",
  "1 X Catalyst Uplink Switch",
  "1 X Cisco UCS Server for Services",
  "1 X Jumpbox",
  "Virtual Machines",
  "1 X VMWARE Vcenter",
  "1 X DNS /AD Server/NTP",
  "1 X HXDP VM",
];

export const CISCO_HYPERFLEX_CARD_LIST = [
  "Version 4.X",
  "3 X HX C220/240 Nodes",
  "2 X FI-6248 Fabric Interconnects",
  "1 X Catalyst Uplink Switch",
  "1 X Jump Box",
  "1 X Jump Box",
  "2 Days Access",
];
